import styled from 'styled-components'
import { Layout } from '../components'

const PrivacyPolicy = () => {
    return (
        <Layout>
            <div className='spacer-100' />
            <Container>
            <h1 style={{textAlign:'center'}}>個人情報の取り扱いについて</h1>
            <div className='spacer-50' />

                <Paragraph style={{textAlign:'right'}}>ニューネックス株式会社</Paragraph>
                <Paragraph style={{textAlign:'right'}}>個人情報保護係</Paragraph>
                <div className='spacer-50' />

                <Paragraph>
                この「個人情報の取り扱いについて」は、ニューネックス株式会社（以下「当社」と称します。）が取得・利用する個人情報を対象として、当社の個人情報に関する基本的な指針を定めるものです。
                当社では、個人情報取扱事業者として個人情報（特定の個人の識別が可能な情報）を取り扱うにあたり、以下の「個人情報保護方針」を定め、個人情報の保護に関する法律、その他関係法令および「個人情報の取り扱いについて」を遵守いたします。
                </Paragraph>

                <div className='spacer-100' />
                <h2 style={{textAlign:'left'}}>個人情報保護方針</h2>
                <div className='spacer-25' />

                <ListWrapper>
                    <List>個人情報の取得、利用および提供にあたっては当社の事業内容および規模を考慮した適切な範囲でこれを行います。</List>
                    <List>個人情報の漏えい、滅失またはき損の防止措置を講ずると共に、万一の発生時には速やかな是正対策を実施します。</List>
                    <List>個人情報の取り扱いに関する法令、国が定める指針その他の規範を遵守します。</List>
                    <List>お客様からの個人情報に関するお問い合わせに、誠実かつ迅速に対応します。</List>
                    <List>個人情報管理の仕組みを継続的に改善します。</List>
                </ListWrapper>

                <div className='spacer-100' />
                <h2 style={{textAlign:'left'}}>個人情報の収集について</h2>
                <div className='spacer-25' />

                <Paragraph>
                通常当サイトを閲覧する場合、
                お客様に関するいかなる情報も入力や開示する必要はなく、匿名のままご自由にご利用いただけます。
                ただし、会員登録や製品購入時、お問い合わせ時等で、
                お客様の氏名、住所、電話番号、メールアドレス等の入力をお願いしております。
                その際以下情報についてCookie等を利用して取得しております。
                <div className='spacer-25' />
                <ListWrapper>
                    <List>アクセス端末の機体種別、OSなどの情報</List>
                    <List>端末ごとに割り振られる広告識別子番号</List>
                    <List>IPアドレス情報</List>
                    <List>インターネット接続に関する情報</List>
                    <List>位置情報</List>
                    <List>リファラー(参照元)情報</List>
                    <List>閲覧URL、日時などに関するタイムスタンプ情報</List>
                    <List>サービスの利用に関する情報</List>
                    <List>サーバログ情報</List>
                </ListWrapper>
                これらの情報の利用目的につきましては「個利用目的について」を、
                管理につきましては「各製品、サービス毎の個人情報の取り扱いについて」をご参照ください。
                </Paragraph>

                <div className='spacer-100' />
                <h2 style={{textAlign:'left'}}>利用目的について</h2>
                <div className='spacer-25' />

                <Paragraph>
                当社は、利用目的を可能な限り特定した上、あらかじめ本人の同意を得た場合および個人情報の保護に関する法律、その他法令により例外として取り扱うことが認められている場合を除き、以下の利用目的の範囲内で個人情報を利用します。
                製品のご購入およびプレゼントなどのご応募に基づく、製品の配送、代金決済、当社からお客様へのお問い合わせ、関連するアフターサービス、その他取引遂行にあたって必要な業務
                会員のご登録に基づく会員サービスおよび関連アフターサービスのご提供にあたって必要な業務
                </Paragraph>

                <div className='spacer-100' />
                <h2 style={{textAlign:'left'}}>新製品、サービスのご案内</h2>
                <div className='spacer-25' />

                <Paragraph>
                お客様から当社になされる、電子メール、郵送、電話およびFAXなどによるお問い合わせへの対応
                上記(1)から(4)に付随した、当社のサービス提供にあたって必要な利用
                お客様の性別・年齢・居住地など個人の属性および購入・閲覧履歴や閲覧環境のマーケティング資料としての社内での利用
                上記の利用目的以外で個人情報を利用する必要が生じた場合には、あらかじめ本人の同意を得た場合および「個人情報の保護に関する法律」その他法令により例外として取り扱うことが認められている場合を除き、その利用についてご本人のご同意をいただくものとします。
                なお、当社では、各業務の一部を委託先に委託し、当該委託先に対して必要な範囲で個人情報の取り扱いを委託する場合があります。この場合には、法令および当社で定めた基準に従って適切な管理を行います。
                </Paragraph>

                <div className='spacer-100' />
                <h2 style={{textAlign:'left'}}>第三者への提供について</h2>
                <div className='spacer-25' />
                <Paragraph>
                当社では、取得した個人情報を以下のいずれかに該当する場合を除き、いかなる第三者にも提供または開示いたしません。
                ご本人の同意がある場合
                人の生命、身体または財産の保護のために必要な場合であって、ご本人のご同意をいただくことが困難な場合
                その他法令にもとづき開示・提供を求められた場合
                ご登録内容の開示、修正および利用中止について
                当社では、業務の適正な遂行を妨げない限りにおいて、ご本人のお申し出により、個人情報をご本人に開示します。その場合、当社所定の方法によって本人確認を行わせていただきます。
                ご本人によるご登録内容の修正および利用中止のご希望につきましては、所定の窓口および手続きにより承り、速やかに対応いたします。
                各製品、サービス毎の個人情報の取り扱いについて
                当社では、各製品、サービスに関するサイト、電子メールその他各種のご案内等において、当該製品、サービス等ごとに個人情報の利用目的、第三者への提供、セキュリティ、お問い合わせ先等、その個人情報の取り扱いについて個別に定めている場合があります。その場合に、「個人情報の取り扱いについて」と異なる定めや特別な定めがあるときには、当該各製品、サービス等ごとに定めた個人情報の取り扱いに関する事項を優先して適用させていただきます。
                </Paragraph>

                <div className='spacer-100' />
                <h2 style={{textAlign:'left'}}>改定について</h2>
                <div className='spacer-25' />
                <Paragraph>
                「個人情報の取り扱いについて」は、関連する法令等の改正や当社の方針の変更等により予告なく変更する場合があります。
                </Paragraph>

                <div className='spacer-100' />
                <h2 style={{textAlign:'left'}}>当サイトの取り組みについて</h2>
                <div className='spacer-50' />
                
                <h3 style={{textAlign:'left', borderBottom: '1px solid #fff'}}>セキュリティ向上の取り組み</h3>
                <div className='spacer-25' />
                <Paragraph>
                当サイトから個人情報およびクレジットカード情報をご入力いただく場合にはSSL（データ暗号化技術）の利用により、入力情報が傍受、妨害または改ざんされることを防ぎます。
                なお、オンラインクレジットカード決済にあたっては、ベリトランス株式会社との提携により、お客様のカード情報はカード会社に送信の上、直接その場で審査・決済されます。
                弊社がクレジットカード情報を保持することはありません。
                <br/>
                <span style={{fontSize: '.7rem', lineHeight: '1rem'}}>
                ※SSL：Secure Sockets Layerの略。
                ウェブサイト上での通信の安全対策として用いられている一般的な技術であり、入力されたデータをインターネットへ送信する際に、通信全体を暗号化する技術。
                </span>
                </Paragraph>
                
                <div className='spacer-25' />
                <h3 style={{textAlign:'left', borderBottom: '1px solid #fff'}}>クッキー（Cookie）の利用について</h3>
                <div className='spacer-25' />
                <Paragraph>
                当サイトでは一部機能（ショッピングカートなど）のご提供にあたり「クッキー（Cookie）」を使用しております。
                これはお客様のコンピューターを識別するためのものであり、お客様のお名前・ご住所・電話番号・メールアドレスといった個人情報をクッキーに格納することはありません。
                <br/>
                <span style={{fontSize: '.7rem', lineHeight: '1rem'}}>
                ※クッキー（Cookie）：サイトにアクセスしているお客様のコンピューターに、サーバーから送られる情報を格納する仕組み。
                </span>
                </Paragraph>
                
                <div className='spacer-25' />
                <h3 style={{textAlign:'left', borderBottom: '1px solid #fff'}}>アクセスログの取得について</h3>
                <div className='spacer-25' />
                <Paragraph>
                当サイトでは、ウェブサイトの保守やサービス改善を目的とし、お客様のアクセス履歴（アクセスログ）を記録しております。 
                このログは、当サイトにアクセスされたお客様の閲覧ページおよび日時、閲覧環境などの履歴情報であり、個人を特定できる情報は含みません。
                </Paragraph>
                
                <div className='spacer-25' />
                <h3 style={{textAlign:'left', borderBottom: '1px solid #fff'}}>お問い合わせ窓口</h3>
                <div className='spacer-25' />
                個人情報の取扱いについてのお問い合わせ
                <div className='spacer-50' />
                <p　style={{textAlign:'right'}}>最終改訂日： 2020年12月20日</p>
            </Container>
            <div className='spacer-100' />
        </Layout>
    )
}
export default PrivacyPolicy

const Container = styled.div`
    width: 640px !important;
    margin: 0 auto;
    @media screen and (max-width:768px){
        width: 100% !important;
        padding: 0 20px;
    }
`
const Paragraph = styled.div`
    line-height: 1.7rem;
    letter-spacing: 0.05rem;
`
const ListWrapper = styled.ul`
    list-style-type: square;
    padding-left: 30px;
`
const List = styled.li`
    line-height: 1.5rem;
    margin-bottom: 1rem;
    letter-spacing: 0.05rem;
`